export const clickPolygon = (val1, val2) => {
  return {
    type: "ACTIVE_POLYGON",
    val1,
    val2,
  };
};
export const selectPolygon = (activePolygon) => {
  return {
    type: "SELECT_POLYGON",
    activePolygon,
  };
};
export const resetState = () => {
  return {
    type: "RESET_STATE",
  };
};

export const SetEntities = (CropArray, TillageArray) => {
  return {
    type: "ENTITIES",
    CropArray,
    TillageArray,
  };
};

export const SetFlagToGetGeoJson = (isGeoJsonFetched) => {
  return {
    type: "IS_GEOJSON_POLYGON_FETCHED",
    isGeoJsonFetched,
  };
};

export const formType = (formDisplay) => {
  return {
    type: "FORM_TYPE",
    formDisplay,
  };
};

export const setUserCropDetails = (cropsDetails) => {
  return {
    type: "SET_USER_CROP_DETAILS",
    cropsDetails,
  };
};
export const setInitialFarms = (farms) => {
  return {
    type: "SET_INITIAL_FARMS",
    farms,
  };
};
export const setInitialBusiness = (business) => {
  return {
    type: "SET_INITIAL_BUSINESS",
    business,
  };
};

export const setAllGeoJsonPolygon = (allGeoJson) => {
  return {
    type: "ALL_GEOJSON_POLYGON",
    allGeoJson,
  };
};

export const allUserRegisteredFields = (allUserRegisteredFields) => {
  return {
    type: "ALL_REGISTERED_FIELDS",
    allUserRegisteredFields,
  };
};

export const addedField = (fieldAdded) => {
  return {
    type: "FIELD_ADDED",
    fieldAdded,
  };
};

export const showFieldWell = (wellCoordinates, isWellShown) => {
  return {
    type: "SHOW_FIELD_WELL",
    wellCoordinates,
    isWellShown,
  };
};

export const removeSelectedField = (irrig_unit_Id, index) => {
  return {
    type: "REMOVE_SELECTED_FIELD",
    irrig_unit_Id,
    index,
  };
};

export const clearSelectedField = () => {
  return {
    type: "CLEAR_SELECTED_FIELD",
  };
};

export const setFarmBusiness = (farms, business) => {
  return {
    type: "SET_FARM_BUSINESS",
    farms,
    business,
  };
};

export const updateFieldPopUpData = (
  fieldName,
  farmName,
  businessName,
  surfaceWaterIrrigation,
  well_details,
  irrig_unit_id,
  farms,
  business,
  surfaceWaterPercentage,
  groundWaterPercentage,
  index
) => {
  return {
    type: "UPDATE_FIELD_POPUP_DATA",
    fieldName,
    farmName,
    businessName,
    surfaceWaterIrrigation,
    well_details,
    irrig_unit_id,
    farms,
    business,
    surfaceWaterPercentage,
    groundWaterPercentage,
    index,
  };
};

export const saveFieldPopUpData = (
  fieldName,
  farmName,
  businessName,
  surfaceWaterIrrigation,
  well_details,
  irrig_unit_id,
  farms,
  business,
  surfaceWaterPercentage,
  groundWaterPercentage
) => {
  return {
    type: "SAVE_FIELD_POPUP_DATA",
    fieldName,
    farmName,
    businessName,
    surfaceWaterIrrigation,
    well_details,
    irrig_unit_id,
    farms,
    business,
    surfaceWaterPercentage,
    groundWaterPercentage,
  };
};
